import {Consts} from "../pages/consts";
import {strengthUnits} from "../../resources/json/jsons";
import {useTranslation} from "react-i18next";
import Select from "react-select";

const StrengthAndStartDate = ({strength, onHandleStrength, strengthUnit, onHandleStrengthUnit, startDate,
                                onHandleStartDate}) => {
  const { t } = useTranslation();

  return(
    <div className="w3-row w3-padding-small w3-margin-top w3-margin-bottom" style={{ display: 'flex', alignItems: 'center' }}>
      <div className="w3-col s2 w3-mobile">
        <label>{t("strength")}*:</label>
      </div>
      <div className="w3-col s1 w3-mobile">
        <input
          value={strength}
          type={Consts.NUMBER}
          min="0"
          className="form-input"
          onChange={(e) => onHandleStrength(e.target.value)}
        />
      </div>
      <div className="w3-col s4 w3-mobile">
        <Select
          id={Consts.STRENGTH_UNIT}
          value={strengthUnits?.filter(
            (option) => option?.value === strengthUnit,
          )}
          options={strengthUnits}
          formatOptionLabel={(o) => t(o?.label)}
          name={Consts.STRENGTH_UNIT}
          onChange={({ value }) => onHandleStrengthUnit(value)}
          placeholder={t("select")}
          className="custom-select-small"
          classNamePrefix="custom-select"
        />
      </div>
      <div className="w3-col s2 w3-mobile">
        <label>{t("intake_start_date")}*</label>
      </div>
      <div className="w3-col s3 w3-mobile">
        <input
          type="date"
          value={startDate}
          className="w3-input w3-border w3-round form-input"
          onChange={(e) => onHandleStartDate(e.target.value)}
        />
      </div>
    </div>
  );
}

export default StrengthAndStartDate;